import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Housemaid} from '../models/housemaid.model';

@Injectable({
  providedIn: 'root'
})
export class HouseMaidsService {

  private host:string = environment.api+'/housemaids';
  constructor(private http: HttpClient) { }

  getAllHouseMaids(){
    return this.http.get(this.host+'/findAll');
  }

  UpdateHouseMaid(houseMaid:Housemaid){
    return this.http.put(this.host,houseMaid);
  }

  CreateHouseMaid(houseMaid:Housemaid){
    return this.http.post(this.host,houseMaid);
  }

  DeleteHouseMaid(houseMaid:Housemaid){
    return this.http.delete(this.host+'/'+houseMaid.houseMaidId);
  }


}
